import { formURL } from "Utils/CommonUtilities";
import BaseApiRequest from "./BaseApiRequest";
import { ENABLE_ONLINE_BANKING_PASSWORD_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class UploadOnlineBankingRequest extends BaseApiRequest {
  method = METHOD.HTTP.POST;

  body = [];

  url = ENABLE_ONLINE_BANKING_PASSWORD_URL;

  constructor(applicantId, applicationId, onlineBankingProductId, password) {
    super();

    this.body = {
      applicationId,
      onlineBankingProductId,
      password,
    };
    const paramList = [applicantId];
    this.url = formURL(this.url, paramList);
  }

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(this.url);

  getBody = () => this.body;
}
